import { apiGetParamsReplace, endpoints } from "./services.constants";
import { _request } from "../helpers/HttpHelper";


import { getTokenFromStorage } from "../helpers/AuthHelper/AuthHelperV2";



import axios from "axios";

export async function postFile(guid, formData) {
    return _request({
        method: "POST",
        body: formData,
        endpoint: apiGetParamsReplace(endpoints.TRANSFER_POST_FILE, guid),
        headers: {           
  
            Accept: "application/json, application/xml, text/plain, text/html, *.*",
        },
        throwError: true,
        skipBodyParsing: true

    });
}


export async function getTransferDto(guid) {
    return _request({
        method: "GET",
        body: null,
        endpoint: apiGetParamsReplace(endpoints.TRANSFER_GET_GROUP, guid),
        headers: {
            Accept: "application/json, application/xml, text/plain, text/html, *.*",
        },
        throwError: true,
        skipBodyParsing: false
    });
}

export async function getHistoryItems(guids) {
    return _request({
        method: "POST",
        body: JSON.stringify(guids),
        endpoint: endpoints.TRANSFER_GET_HISTORY,
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json, application/xml, text/plain, text/html, *.*",
        },
        throwError: true,
        skipBodyParsing: false
    });
}

export async function getUser() {


    return _request({
        method: "GET",
        endpoint: endpoints.GET_USER,
        headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            Accept: "application/json, application/xml, text/plain, text/html, *.*",
            "x-organization-id": "1"
        },
        throwError: true,
        skipBodyParsing: false
    });
    }

export async function postFileWithProgress(guid, formData, onUploadProgress) {

      return await axios.post(apiGetParamsReplace(endpoints.TRANSFER_POST_FILE, guid), formData, {
        headers: {
          Accept: "application/json, application/xml, text/plain, text/html, *.*",
        },
        throwError: true,
        onUploadProgress: onUploadProgress
      });
    }

export async function hasTransferPermission() {
    return _request({
        method: "GET",
        body: null,        
        
        endpoint: apiGetParamsReplace(endpoints.TRANSFER_HAS_PERMISSION),
        headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            Accept: "application/json, application/xml, text/plain, text/html, *.*",
            "x-organization-id": "1"
        },
        throwError: true,
        skipBodyParsing: false
    });
}

    /*
     (progressEvent) => {
          const total = progressEvent.total || progressEvent.loaded; // fallback
          const percentCompleted = Math.round((progressEvent.loaded * 100) / total);
          setUploadProgress(percentCompleted);
        },
        */